import { Button, Dialog, Flex, Text } from '@applyboard/crystal-ui';
import { ProfileState } from '../../clients';
import { UserWithState } from './UserStateActions';

interface ConfirmStateChangeDialogProps {
  user: UserWithState;
  newState: ProfileState;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: (id: string) => void;
  userType?: string; // For dialog text (e.g., "User", "Agent")
}

export function ConfirmStateChangeDialog({
  user,
  newState,
  isLoading,
  onClose,
  onConfirm,
  userType = 'User',
}: ConfirmStateChangeDialogProps): JSX.Element {
  const isEnabling = newState === ProfileState.active;
  const actionText = isEnabling ? 'enable' : 'disable';
  const ActionText = isEnabling ? 'Enable' : 'Disable';

  const handleConfirm = () => {
    onConfirm(user.id);
  };

  return (
    <Dialog open onOpenChange={onClose}>
      <Dialog.Heading>
        {ActionText} {userType}
      </Dialog.Heading>
      <Dialog.Content>
        <Flex direction="column" align="start" gap={4}>
          <Text variant="bodyL">
            Are you sure you want to {actionText}{' '}
            <strong>
              {user.givenName} {user.familyName || ''}
            </strong>
            ?
          </Text>
          {!isEnabling && (
            <Text variant="bodyM">Disabled {userType.toLowerCase()}s will not be able to access the platform.</Text>
          )}
        </Flex>
      </Dialog.Content>
      <Dialog.Actions>
        <Dialog.CloseButton width="fill">Cancel</Dialog.CloseButton>
        <Button
          intent={isEnabling ? 'primary' : 'negative'}
          width="fill"
          type="button"
          onClick={handleConfirm}
          loading={isLoading}
        >
          {`${ActionText} ${userType}`}
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
}
